export default __webpack_public_path__ + "ask-ai-icon@2x.png";